module.exports = __webpack_public_path__ + "img/5c3a943.jpg";